import { type ReactNode } from "react";

import { cn } from "#utils";

interface Props {
  isOpen: boolean;
  children: ReactNode;
  className?: string;
}

/**
 * A push panel that sits immediately to the right of the sidebar and shifts
 * the main content area when open, rather than overlaying it. Width animates
 * between 0 and 16rem; overflow-hidden clips content during the transition so
 * the inner div can stay at the full panel width at all times.
 */
export function SidebarPopout({ isOpen, children, className }: Props) {
  return (
    <div
      className={cn(
        "flex h-screen flex-shrink-0 flex-col overflow-hidden",
        "bg-background-secondary transition-[width] duration-200 ease-in-out",
        isOpen ? "w-[16rem] border-l border-outline-decorative shadow-lg" : "w-0",
        className,
      )}
    >
      {/* Fixed-width inner div so content doesn't animate its own width. */}
      <div className="w-[16rem] flex-1 overflow-y-auto" style={{ scrollbarWidth: "none" }}>
        {children}
      </div>
    </div>
  );
}
